export const normalizeAccountType = (accountType) => String(accountType || '').toLowerCase();

export const isFreeOrStudentPlan = (accountType) => ['free', 'student'].includes(normalizeAccountType(accountType));

export const isProfessionalPlan = (accountType) => normalizeAccountType(accountType) === 'professional';

// Handout bundle is a Clinic feature, but Free/Student users should first be prompted to upgrade to Pro.
export const getHandoutBundleUpgradeTarget = (accountType) => {
    if (isFreeOrStudentPlan(accountType)) return 'professional';
    if (isProfessionalPlan(accountType)) return 'clinic';
    return null;
};
